import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=5d2df2cb&scoped=true"
import script from "./Remark.vue?vue&type=script&lang=js"
export * from "./Remark.vue?vue&type=script&lang=js"
import style0 from "./Remark.vue?vue&type=style&index=0&id=5d2df2cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2df2cb",
  null
  
)

export default component.exports